module.exports = __webpack_public_path__ + "static/media/contract-x-logo.4275ec28.png";